import { createContext } from 'react';

export type TCronGeneratorTab = 'seconds' | 'minutes' | 'hours' | 'day' | 'month' | 'year';
export type TFieldName = 'seconds' | 'minutes' | 'hours' | 'dayOfMonth' | 'month' | 'dayOfWeek' | 'year';
export enum TabOptions {
	EVERY_OPTION = 'EVERY_OPTION',
	EVERY_STARTING_OPTION = 'EVERY_STARTING_OPTION',
	EVERY_STARTING_OF_MONTH_OPTION = 'EVERY_STARTING_OF_MONTH_OPTION',
	SPECIFIC_OPTION = 'SPECIFIC_OPTION',
	SPECIFIC_OF_WEEK_OPTION = 'SPECIFIC_OF_WEEK_OPTION',
	SPECIFIC_OF_MONTH_OPTION = 'SPECIFIC_OF_MONTH_OPTION',
	EVERY_BETWEEN_OPTION = 'EVERY_BETWEEN_OPTION',
	LAST_DAY_OF_MONTH_OPTION = 'LAST_DAY_OF_MONTH_OPTION',
	LAST_WEEKDAY_OF_MONTH_OPTION = 'LAST_WEEKDAY_OF_MONTH_OPTION',
	LAST_OF_MONTH_OPTION = 'LAST_OF_MONTH_OPTION',
	LAST_BEFORE_END_OPTION = 'LAST_BEFORE_END_OPTION',
	NEAREST_WEEKDAY_OPTION = 'NEAREST_WEEKDAY_OPTION',
	ON_DAY_OF_MONTH_OPTION = 'ON_DAY_OF_MONTH_OPTION',
}

export interface ICronGeneratorState {
	visibleForm: TCronGeneratorTab;
	seconds: string;
	minutes: string;
	hours: string;
	dayOfMonth: string;
	month: string;
	dayOfWeek: string;
	year: string;
}

export const cronGeneratorInitialState: ICronGeneratorState = {
	// visibleForm: 'seconds',
	visibleForm: 'minutes',
	seconds: '*',
	minutes: '*',
	hours: '*',
	dayOfMonth: '?',
	month: '*',
	dayOfWeek: '*',
	year: '*',
};

export interface ICronGeneratorContext extends ICronGeneratorState {
	changeVisibleForm(value: TCronGeneratorTab): void;
	setFieldValue(fieldName: TFieldName, value: string): void;
}

export const CronGeneratorContext = createContext<ICronGeneratorContext>({
	changeVisibleForm: () => undefined,
	setFieldValue: () => undefined,
	...cronGeneratorInitialState,
});
